// extracted by mini-css-extract-plugin
export default {"root":"styles_root__V+DhF","dragging-over":"styles_dragging-over__Lbg6g","draggingOver":"styles_dragging-over__Lbg6g","color":"styles_color__NuRxs"};